import { Children, forwardRef } from 'react'
import Table from 'components/table/Table'
import PropTypes from 'prop-types'
import { noop } from 'utils'

const FixedTable = forwardRef(
  ({ caption, children, loading, emptyMessage, onScroll = noop }, ref) => {
    const childrenArray = Children.toArray(children)
    const head = childrenArray.find(node => node && node?.type === Table.Head)
    const body = childrenArray.find(node => node && node?.type === Table.Body)
    const columns = head?.props.children.filter(
      node => node && node.type === Table.Column
    )
    return (
      <div className="itemtbl_wrap">
        <div className="itemtbl_head">
          <Table
            className="tbl_itemchoice"
            caption={`${caption ? `${caption} 제목` : ''}`}>
            {head}
          </Table>
        </div>
        <div className="itemtbl_body" ref={ref} onScroll={onScroll}>
          <Table
            className="tbl_itemchoice"
            caption={`${caption ? `${caption} 내용` : ''}`}
            loading={loading}
            emptyMessage={emptyMessage}>
            <Table.Head noHead>
              {columns.map(({ props: { key, title, ...rest } }, index) => (
                <Table.Column key={key || index} {...rest} />
              ))}
            </Table.Head>
            {body}
          </Table>
        </div>
      </div>
    )
  }
)
FixedTable.displayName = 'FixedTable'
FixedTable.propTypes = {
  caption: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.node,
  onScroll: PropTypes.func,
}
export default FixedTable
